import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

export const IconButton = ({ ariaLabel, iconClass, className, children, ...otherProps }) => {
    return (
        <button type="button" aria-label={ariaLabel} className={clsx(className)} {...otherProps}>
            {iconClass ? <span className={iconClass} aria-hidden="true"></span> : null}
            {children}
        </button>
    );
};

IconButton.propTypes = {
    ariaLabel: PropTypes.string.isRequired,
    iconClass: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
};

export default IconButton;
